import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Badge, Card, Col, Row, Container, Button } from "reactstrap"
import { getFeesDetailsReset, fetchAllowedModulesRequest } from "store/actions"
import { GetTestReset } from "store/TeacherApp/Exam/Action"
//i18n
import { getStudentReset } from "store/actions"
import axios from "axios"
import { withTranslation } from "react-i18next"
import { compareVersions } from "compare-versions"
// Import Css for dashboard
import "./Dashboard.css"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import Spinners from "components/Common/Spinner"
import { Link } from "react-router-dom"
import AppUpdate from "components/Common/AppUpdate"

const Dashboard = props => {
  document.title = "Prisms | Dashboard"
  const dispatch = useDispatch()
  const OS = localStorage.getItem("OS")

  const [sections, setSections] = useState([])
  const [isUpdate, setIsUpdate] = useState(false)
  const [iosV, setIosV] = useState()
  const [androidV, setAndroidV] = useState()

  const { dashIcons, Loading, errors, successMsg, url } = useSelector(
    state => state.DashReducer
  )

  // Add Module name for Testing only or if you are working on localhost
  const addModuleToSection = (sectionName, newModule) => {
    setSections(prevSections =>
      prevSections.map(section =>
        section.SectionName === sectionName
          ? {
            ...section,
            Modules: [...section.Modules, newModule],
          }
          : section
      )
    )
  }

  const transformData = data => {
    const transformedData = {}

    data.forEach(item => {
      const { section_name, module_name, url, icon, section_colour } = item
      if (!transformedData[section_name]) {
        transformedData[section_name] = {
          SectionName: section_name,
          SectionColor: section_colour,
          Modules: [],
        }
      }
      transformedData[section_name].Modules.push({ module_name, url, icon })
    })

    return Object.values(transformedData)
  }

  const addAlpha = (color, opacity) => {
    const _opacity = Math.round(Math.min(Math.max(opacity ?? 1, 0), 1) * 255)
    return color + _opacity.toString(16).toUpperCase()
  }
  const newModule = {
    module_name: "Lesson Plan",
    url: "/lesson-home",
    icon: "fas fa-clipboard",
  }

  useEffect(() => {
    if (Array.isArray(dashIcons) && dashIcons.length > 0) {
      let data = transformData(dashIcons)

      setSections(data)
    }

    // addModuleToSection("Teacher Admin", newModule)
  }, [dashIcons])

  useEffect(() => {
    if (errors && errors !== null) {
      toast.error(errors)
    }
    if (successMsg && successMsg !== null) {
      toast.success(successMsg)
    }
  }, [errors, successMsg])

  useEffect(() => {
    dispatch(getFeesDetailsReset())
    dispatch(GetTestReset())
    localStorage.removeItem("div_id")
    localStorage.removeItem("sortOrder")
    dispatch(getStudentReset())
  }, [])
  const live_Url = "https://marcopolo.prisms.in"

  useEffect(() => {
    const getAcadId = async () => {
      try {
        const response = await axios.post(
          `${live_Url}/api/tscommon/getCurrentAcad`,
          { sid: localStorage.getItem("sid").replace(/"/g, "") }
        )
        localStorage.setItem("acad_id", response.data[0]?.acadid)
        // setCurrentAcadId(response.data[0]?.acadid)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }

    const getAppVersion = async () => {
      try {
        const response = await axios.get(
          `${live_Url}/api/parent-auth/appVersion`
        )
        // console.log(response.data[0].android_version_number)
        setAndroidV(response.data[0].android_version_number)
        setIosV(response.data[0].ios_version_number)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }

    dispatch(fetchAllowedModulesRequest())
    getAppVersion()
    getAcadId()
  }, [])

  useEffect(() => {
    const os_build = localStorage.getItem("os_build")

    if (!os_build) return

    if (OS === "android" && androidV) {
      if (compareVersions(androidV, os_build) === 1) {
        setIsUpdate(true)
      }
    } else if (OS === "ios" && iosV) {
      if (compareVersions(iosV, os_build) === 1) {
        setIsUpdate(true)
      }
    }
  }, [androidV, iosV])

  return (
    <React.Fragment>
      <div className="page-content">
        {isUpdate && (
          <Row>
            <AppUpdate OS={OS} />
          </Row>
        )}
        {Loading ? (
          <Spinners />
        ) : (
          sections &&
          sections.length > 0 &&
          sections.map(section => (
            <Row
              className="border rounded-2 shadow bg-white mb-2 pb-3"
              key={section.SectionName}
            >
              <div className="three">
                <h2
                  className="fw-normal text-dark"
                  style={{
                    fontFamily: "Poppins",
                  }}
                >
                  {section.SectionName}
                </h2>
              </div>
              {section.Modules.map(module => {
                let isExternalLink = false;
                try {
                  const resolvedUrl = new URL(module.url, window.location.origin);
                  isExternalLink = resolvedUrl.origin !== window.location.origin;
                } catch (e) {
                  isExternalLink = false; // If the URL is malformed, assume internal
                }

                console.log(`${module.url} → external:`, isExternalLink);

                return (
                  <Col md={2} xs={4} key={module.module_name}>
                    <Link
                      className="d-flex flex-column align-items-center justify-content-center mt-2"
                      to={isExternalLink ? "/external-link" : module.url}
                      state={{ webLink: module.url }}
                    >
                      <div
                        className="iconContainer shadow-sm"
                        style={{ background: addAlpha(section.SectionColor, 0.1) }}
                      >
                        <i className={`${module.icon} dashIcons`} style={{ color: section.SectionColor }}></i>
                      </div>
                      <span className="IconText" style={{ fontFamily: "Poppins" }}>
                        {module.module_name}
                      </span>
                    </Link>
                  </Col>
                );
              })}

            </Row>
          ))
        )}
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
